import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import dateFormat from "dateformat";
import { Image } from "react-bootstrap";

import { searchOpportunityRecommendedStreams } from "src/legacy/redux/actions/search";
import { fetchCRMEnabledIntegration } from "src/legacy/redux/actions/integrations";

import NoIntegration from "src/legacy/images/integrations/nointegration.png";
import styles from "./styles.module.scss";

const PaperfliteIcon = '/images/Paperflite.png';
const DefaultAssetIcon = '/images/defaultIcons/default_asset.jpg';

export default function OpportunityRecommendedStreamContainer(props) {
  const dispatch = useDispatch();

  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const port = window.location.port;

  const url = `${protocol}//${hostname}${port ? `:${port}` : ""}`;

  const streams = useSelector((state) =>
    _.get(state, "legacyRootReducer.search.opportunityRecommendedStreamContents.streams", [])
  );

  const [noIntegration, setNoIntegration] = useState(false);

  const [showStream, setShowStream] = useState(false);

  useEffect(() => {
    dispatch(fetchCRMEnabledIntegration()).then((response) => {
      if (response.payload.errors) {
        setNoIntegration(true);
      } else {
        const opportunityId = window.location.pathname.split('/')[3];
        dispatch(searchOpportunityRecommendedStreams(opportunityId)).then(
          () => {
            setShowStream(true);
          }
        );
      }
    });
  }, []);

  const _renderStream = () => {
    return (
        <div className={styles.verticalContainer}>
          {streams?.length > 0 && streams?.map((stream) => (
            <div className={styles.streamItem}>
              <a href={`${url}/streams/${stream.id}`} target="_blank">
                <Image
                  src={stream.icon ? stream.icon.thumbnail : DefaultAssetIcon}
                  className={styles.streamIcon}
                ></Image>
              </a>
              <div className={styles.extradetails}>
              <a href={`${url}/streams/${stream.id}`} target="_blank">
                <span className={styles.streamName}>{stream.name}</span>
                </a>
                <span className={styles.streamCreatedBy} >Created By {stream.createdBy.firstName}</span>
                <span className={styles.streamUpdatedBy}>
                  <span className={styles.updateContent}>Updated :</span>

                  {dateFormat(new Date(stream.modifiedDate), "dd mmm yyyy")}

                </span>
              </div>
            </div>
          ))}
        </div>
      );
  };

  const renderLogo = () => {
    return (
      <div className={styles.headerLogo}>
        <span className={styles.headerLogoText}> Powered by </span>
        <Image className={styles.headerLogo} src={PaperfliteIcon} />
      </div>
    );
  };

  const renderTitle = () => {
    return (
      <div className={styles.recommendedStreamDiv}>
        <div className={styles.title}>Recommended Stream for opportunity</div>
      </div>
    );
  };

  const integrationNotFound = () => {
    return (
      <div className={styles.error}>
        <div className={styles.errorImageDiv}>
          <Image className={styles.errorImage} src={NoIntegration} />
        </div>
        <div className={styles.errorTitle}>
          Your Integration has been deactivated in Paperflite
        </div>
      </div>
    );
  };

  return (
    <div className={styles.recommendations}>
      {renderLogo()}
      {noIntegration && integrationNotFound()}
      {showStream && renderTitle()}
      {showStream && _renderStream()}
    </div>
  );
}